var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSmiley3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 80,
    viewBox: "0 0 80 80",
    width: 80,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "a",
    cx: "50%",
    cy: "17.266846%",
    r: "64.009264%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffc13c"
  })), /*#__PURE__*/React.createElement("path", {
    id: "b",
    d: "m0 39.9997654c0-22.0914749 17.9081363-39.9997654 40.0023465-39.9997654 22.0895172 0 39.9976535 17.9082905 39.9976535 39.9997654 0 22.0910056-17.9081363 40.0002346-39.9976535 40.0002346-22.0942102 0-40.0023465-17.909229-40.0023465-40.0002346"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "c",
    height: "107.5%",
    width: "107.5%",
    x: "-3.8%",
    y: "-3.8%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "SourceAlpha",
    result: "shadowBlurInner1",
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0,
    in: "shadowBlurInner1",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic",
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowInnerInner1",
    type: "matrix",
    values: "0 0 0 0 0.952941176   0 0 0 0 0.529411765   0 0 0 0 0.0431372549  0 0 0 1 0"
  })), /*#__PURE__*/React.createElement("path", {
    id: "d",
    d: "m22.9999413 48.1854605c.9620461 8.5376569 8.2032029 15.1742504 17.0024052 15.1742504 8.7945093 0 16.0356661-6.6365935 16.9977122-15.1742504z"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "e",
    height: "126.4%",
    width: "111.8%",
    x: "-5.9%",
    y: "-13.2%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "SourceAlpha",
    result: "shadowBlurInner1",
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 1,
    in: "shadowBlurInner1",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic",
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowInnerInner1",
    type: "matrix",
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.5 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "url(#a)",
    fillRule: "evenodd",
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#c)",
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#a36407",
    fillRule: "evenodd",
    xlinkHref: "#d"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#e)",
    xlinkHref: "#d"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#ea493c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m28.2559981 58.6865955c3.0644688 2.8945346 7.1942277 4.6731154 11.7463484 4.6731154 4.3503255 0 8.3205256-1.6270025 11.3427582-4.30379l-.1595589-.3679175c-11.4178447-5.5670986-22.7746817-.0774316-22.9295477-.0014079"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m34.4834868 24.368598.0046929-.0586604c0-3.6937227-2.6749574-7.0758419-6.6920865-7.0758419-3.1911774 0-5.0401831 2.293853-5.6737256 4.4412898-.6288497-2.1474368-2.4825483-4.4412898-5.6737256-4.4412898-4.0171291 0-6.68739369 3.3821192-6.68739369 7.0758419v.0586604c-.01877163.8038809 0 8.9815982 12.35642639 15.6468179v.0018772l.0046929-.0009386v.0009386l.0046929-.0009386v.0009386-.0018772c12.3611192-6.6652197 12.3798909-14.842937 12.3564263-15.6468179"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m70.2387517 24.368598v-.0586604c0-3.6937227-2.6702646-7.0758419-6.6873937-7.0758419-3.1911773 0-5.040183 2.293853-5.6737256 4.4412898-.6288496-2.1474368-2.4825482-4.4412898-5.6737256-4.4412898-4.0171291 0-6.6873936 3.3821192-6.6873936 7.0758419v.0586604c-.0187717.8038809 0 8.9815982 12.3564263 15.6468179v.0018772l.0046929-.0009386v.0009386l.0046929-.0009386v.0009386-.0018772c12.3611193-6.6652197 12.3798909-14.842937 12.3564264-15.6468179"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmiley3);
export default __webpack_public_path__ + "static/media/smiley-3.0d852d9589bce5dbddb6cc0ef54e462d.svg";
export { ForwardRef as ReactComponent };